// Builds the API login URL. `origin` tells the API which deployment (prod,
// staging, Vercel preview) started the login so it can send the user back there.
export const loginRedirectUrl = (params: { path?: string; token?: string } = {}) => {
    const query = new URLSearchParams({ origin: window.location.origin })
    if (params.path) query.set('path', params.path)
    if (params.token) query.set('token', params.token)
    return `/api/v1/auth/loginRedirect?${query.toString()}`
}

/** Send the browser to Discord login, coming back to the current page with its query string intact. */
export const redirectToLogin = () => {
    window.location.href = loginRedirectUrl({ path: window.location.pathname + window.location.search })
}
